import { postRequestFormData } from './utilities/http';

export const convertFairFile = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return await postRequestFormData(`/converter/dxf-svg`, formData);
};
